import { useState } from 'react';
import useToast from 'hooks/useToast';
import { validateForm } from 'pages/Forms/FormResults/FormResultDetails/Response/ValidationSchemas';
import { useQRScreenNavigation } from 'hooks/navigation/useQRSCreenNavigation';
import { Setting } from 'pages/Forms/types/form';
import { useSaveResponseMutation } from '../api/mutations';
import { useQRFlow } from './useQRFlow';

type UseAddResponseProps = {
  formID: string;
  form_title: string;
  formDescription: string;
  formFields: any[];
  setting: Setting;
  disablePrompt: () => void;
};
export const useAddResponse = ({
  formID,
  form_title,
  formDescription,
  formFields,
  setting,
  disablePrompt,
}: UseAddResponseProps) => {
  const [formFieldErrors, setFormFieldErrors] = useState<
    Record<string, string>
  >({});
  const toast = useToast();
  const { goToResponseReceived } = useQRScreenNavigation();
  const { mutate: saveResponse, isPending: isSavingResponse } =
    useSaveResponseMutation();
  const { clearLocalStorage } = useQRFlow();

  const handleFormAnswerEntrySubmit = () => {
    const fieldErrors = validateForm(formFields);
    setFormFieldErrors(fieldErrors);
    if (Object.keys(fieldErrors)?.length === 0) {
      const payload = {
        form: formID,
        form_answer: {
          title: form_title,
          description: formDescription,
          elements: formFields,
          setting: setting,
        },
        user_form_status: 'Submitted',
        from_qr: true,
      };
      disablePrompt();
      saveResponse(payload, {
        onSuccess: () => {
          toast.success('Response saved successfully');
          goToResponseReceived();
          clearLocalStorage();
        },
        onError: () => {
          toast.error('Failed to save response');
        },
      });
    } else {
      toast.error('Please fill out all required fields correctly.');
    }
  };

  return {
    handleFormAnswerEntrySubmit,
    formFieldErrors,
    isSavingResponse,
  };
};
